import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const UOMs = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'KG' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Kilograms' },
    { name: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Units of Measurement"
      endpoint="uoms"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN']}
    />
  );
};

export default UOMs;
